import axios from "../http"; // 导入axios实例
import qs from "qs"; // 根据需求是否导入qs模块

const getUser ={
    getUserInfos(params) {
        //提交申诉
        return axios.post(`/mobile/page/user_all`, qs.stringify(params));
    },
    getUserInfo(params) {
        return axios.post(`/mobile/page/pc_user_info`,qs.stringify(params));
    },
    getAddress(params) {
        return axios.post(`/mobile/page/pc_show_address`,qs.stringify(params));
    },
    getGrade(params) {
        return axios.post(`/mobile/page/running_water`,qs.stringify(params));
    },
    //意见反馈
    get_complaint_pro(params) {
        return axios.post(`/mobile/page/feedback_type`, qs.stringify(params));
    },
    submit_complaint(params) {
        return axios.post(`/mobile/page/saveadd`, qs.stringify(params));
    },
    //地址
    get_addresslist(params) {
        return axios.post("/common/ad/lists_area", qs.stringify(params));
    },
    //添加地址
    addAress(params) {
        return axios.post(`/mobile/page/add_address`, qs.stringify(params))
    },
    //获取地址信息
    getAddressInfor(params) {
        return axios.post(`/mobile/page/edit_address_infor`, qs.stringify(params))
    },
    //修改地址
    setDefaultAddress(params) {
        return axios.post(`/mobile/page/edit_address`, qs.stringify(params))
    },
    //删除地址
    delAddres(params) {
        return axios.post(`/mobile/page/del_address`, qs.stringify(params))
    },
    setMyInfo(params) {
        return axios.post(`/mobile/page/complete_info`, qs.stringify(params))
    },
    //修改密码
    changePassword(params) {
        return axios.post(`/mobile/page/change_password`, qs.stringify(params))
    },
    //添加充值订单到recharge表
    RechangePay(params) {
        return axios.post(`/mobile/page/rechangePay`, qs.stringify(params))
    },
    getKfList(params) {
        return axios.post(`/mobile/page/service`, qs.stringify(params));
    },

    getAuroraId(params) {
        return axios.post(`/mobile/ucenter/aurora`, qs.stringify(params));
    },
    getLoginBg(params) {
        return axios.post(`/mobile/power/find_by_cate`, qs.stringify(params));
    },
    getConfig(params) {
        return axios.post(`/mobile/power/plugin_open_all`, qs.stringify(params));
      },
}
export default getUser;


// WEBPACK FOOTER //
// ./src/assets/js/api/require/user.js